import * as Cesium from '@cesiumgs/cesium-analytics'
import { convertCoordinates, defineProj } from '@/components/Cesium/Prj4/Prj4'

class MeasurePoint {
  cesiumview: any = null
  lineEntity = new Cesium.Entity()
  _drawLayer: any = null
  handler: any = null
  cancelHandler: any = null
  callbackfn: any
  endCallBackFn: any
  constructor(vivewr: Cesium.Viewer, callback?: any, endCallBack?: any) {
    this.cesiumview = vivewr
    this._drawLayer = new Cesium.CustomDataSource('measurePoint')
    this.cesiumview && this.cesiumview.dataSources.add(this._drawLayer)
    this.handler = new Cesium.ScreenSpaceEventHandler(
      this.cesiumview.scene.canvas,
    )
    this.cancelHandler = new Cesium.ScreenSpaceEventHandler(
      this.cesiumview.scene.canvas,
    )
    this.callbackfn = callback
    this.endCallBackFn = endCallBack
  }

  create() {
    this.move()
  }

  move() {
    this.handler.setInputAction((movement: any) => {
      let position
      if (this.cesiumview.scene.pickPositionSupported) {
        const pickedObject = this.cesiumview.scene.pick(
          movement.endPosition,
          1,
          1,
        )

        if (this.filterPickForMeasurement(pickedObject)) {
          position = this.cesiumview.scene.pickPosition(
            movement.endPosition,
            new Cesium.Cartesian3(),
          )
        }
        else {
          if (!Cesium.defined(this.cesiumview.scene.globe)) {
            return
          }
          this.cesiumview.scene.globe.depthTestAgainstTerrain = true
          const ray = this.cesiumview.camera.getPickRay(movement.endPosition)
          position = this.cesiumview.scene.globe.pick(
            ray,
            this.cesiumview.scene,
          )
        }
      }

      if (position) {
        const cartographic
          = this.cesiumview.scene.globe.ellipsoid.cartesianToCartographic(
            position,
          )

        const lat = Cesium.Math.toDegrees(cartographic.latitude).toFixed(4)
        const lng = Cesium.Math.toDegrees(cartographic.longitude).toFixed(4)
        const height = cartographic.height.toFixed(2)
        defineProj('EPSG:5186', '+proj=tmerc +lat_0=38 +lon_0=127 +k=1 +x_0=200000 +y_0=600000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs +type=crs')
        const sss = convertCoordinates('EPSG:4326', 'EPSG:5186', [
          Number(lng),
          Number(lat),
        ])
        this._addInfoPoint(position, {
          lat: Number(lat).toFixed(6),
          lng: Number(lng).toFixed(6),
          x: sss.x.toFixed(2),
          y: sss.y.toFixed(2),
          height,
        })
        if (this.callbackfn instanceof Function) {
          this.callbackfn(height)
        }
      }
    }, Cesium.ScreenSpaceEventType.MOUSE_MOVE)

    this.cancelHandler.setInputAction((movement: any) => {
      this.clear()
    }, Cesium.ScreenSpaceEventType.LEFT_DOUBLE_CLICK)
  }

  filterPickForMeasurement(object: any) {
    // Passing a primtive directly
    if (this.isPrimitivePickable(object)) {
      return true
    }

    // Passing a pick result
    const objectPickable
      = Cesium.defined(object)
      && (object instanceof Cesium.Cesium3DTileFeature
        || object instanceof Cesium.ModelFeature)

    if (objectPickable) {
      return true
    }

    // Is the pickedObject's primitive pickable
    const primitivePickable
      = Cesium.defined(object) && this.isPrimitivePickable(object.primitive)

    return primitivePickable
  }

  isPrimitivePickable(primitive: any) {
    return (
      Cesium.defined(primitive)
      && (primitive instanceof Cesium.Cesium3DTileset
        || primitive instanceof Cesium.Model
        || primitive instanceof Cesium.ModelExperimental
        || primitive instanceof Cesium.Cesium3DTileFeature)
    )
  }

  clear() {
    this._drawLayer.entities.removeAll()
    this.handler.destroy()
    if (this.endCallBackFn) {
      this.endCallBackFn()
    }
  }

  _addInfoPoint(position: any, { lat, lng, x, y, height }: any) {
    this._drawLayer.entities.removeAll()
    const _labelEntity = new Cesium.Entity({
      position,
      point: {
        pixelSize: 5,
        outlineColor: Cesium.Color.YELLOW,
        outlineWidth: 2,
      },
      label: {
        text: `경위도 좌표 (EPSG :4326) \n경도:${lng} \n위도:${lat}  \nGRS80 중부원점 (EPSG: 5186)\nx:${x} \ny:${y} \n고도:${height} m`,
        show: true,
        showBackground: true,
        font: '16px monospace',
        horizontalOrigin: Cesium.HorizontalOrigin.LEFT,
        verticalOrigin: Cesium.VerticalOrigin.BOTTOM,
        pixelOffset: new Cesium.Cartesian2(-20, -50), // left top
        disableDepthTestDistance: 10000,
      },
    })

    this._drawLayer.entities.add(_labelEntity)
  }
}
export default MeasurePoint
